import { Action, createReducer, on } from '@ngrx/store';
import { IEmployeeDetailRequest, IEmployeeDetailResponse } from '../models/employee-detail.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  loadEmployeeDetailsRequest,
  loadEmployeeDetailsSuccess,
  loadEmployeeDetailsFailure,
  clearEmployeeDetails
} from '../actions/employee-detail.actions';

export const employeeDetailFeatureKey = 'employeeDetail';

export interface EmployeeDetailState {
  employeeDetailRequest: string | null;
  employeeDetailSuccess: IEmployeeDetailResponse | null;
  employeeDetailFailure: IGenericError<ErrorResponse> | null;
  loaded: boolean;
}

export const initialState: EmployeeDetailState = {
  employeeDetailRequest: null,
  employeeDetailSuccess: null,
  employeeDetailFailure: null,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(loadEmployeeDetailsRequest, (state, action) => ({
    ...state,
    employeeDetailRequest: action.request
  })),
  on(loadEmployeeDetailsSuccess, (state, action) => ({
    ...state,
    employeeDetailSuccess: action.response,
    loaded: true
  })),
  on(loadEmployeeDetailsFailure, (state, action) => ({
    ...state,
    employeeDetailFailure: action.error
  })),
  on(clearEmployeeDetails, (state, action) => ({
    ...state,
    employeeDetailRequest: null,
    employeeDetailSuccess: null,
    employeeDetailFailure: null,
    loaded: false
  }))
);

export const getEmployeeDetailsRequest = (state: EmployeeDetailState) => state.employeeDetailRequest;
export const getEmployeeDetailsResponse = (state: EmployeeDetailState) => state.employeeDetailSuccess;
export const getEmployeeDetailsFailure = (state: EmployeeDetailState) => state.employeeDetailFailure;
export const getEmployeeDetailsIsLoaded = (state: EmployeeDetailState) => state.loaded;
